import axiosInstance from '../utils/axiosInstance';

const getDataResult = (response) => response.data?.data ?? response.data ?? {};

export const fetchFireIncidents = async (params = {}) => {
  const response = await axiosInstance.get('/fire/incidents', { params });
  return {
    data: getDataResult(response) || [],
    pagination: response.data?.pagination || {},
  };
};

export const fetchFireIncident = async (id) => {
  const response = await axiosInstance.get(`/fire/incidents/${id}`);
  return getDataResult(response);
};

export const acceptFireIncident = async (id) => {
  const response = await axiosInstance.post(`/fire/incidents/${id}/accept`);
  return getDataResult(response);
};

export const closeFireIncident = async (id, resolution) => {
  const response = await axiosInstance.post(`/fire/incidents/${id}/close`, { resolution });
  return getDataResult(response);
};

export const fetchFireActiveSchools = async () => {
  const response = await axiosInstance.get('/fire/active-schools');
  return getDataResult(response) || [];
};

export const fetchFirePanelStatus = async ({ deviceId, schoolIp, objectId } = {}) => {
  const params = {};
  if (deviceId != null) params.deviceId = deviceId;
  if (schoolIp) params.schoolIp = schoolIp;
  if (objectId != null) params.objectId = objectId;
  const response = await axiosInstance.get('/fire/panel-status', { params });
  return getDataResult(response);
};

export const fetchFireSnapshotBlob = async (id) => {
  const response = await axiosInstance.get(`/fire/incidents/${id}/snapshot`, {
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
};
